// extracted by mini-css-extract-plugin
module.exports = {"welcome":"home_welcome__2clCd","searchloading":"home_searchloading__3RjbG"};